/* global ViewController, WebView */
var rfqPriceController = new ViewController({
    directory : "views/public",
    name: "rfqPrice",
    container: "main",
    route: "rfq-price"
}) ;

rfqPriceController.prepareDataOnEnter = function(token, callback){
    this.api.public.getRfqPrice(token, function(err, rfq){
        if(err){
            if(err === "NOT_FOUND"){
                return callback(null, { notfound: true }) ;
            }
            return callback(err) ;
        }
        rfq.token = token ;
        rfq.closed = (rfq.rfq.state === "done" || rfq.rfq.state === "cancel") ;
        callback(null, rfq) ;
    }.bind(this)) ;
};

rfqPriceController.onDownloadTerms = function(){
    this.view.longTask(function(done){
        this.api.public.downloadPurchaseTerms(done);
    }.bind(this));
};

rfqPriceController.onSave = function(){
    this.view.updateData() ;
    var prices = [] ;
    this.data.lines.forEach(function(l){
        l.lineSuppliers.forEach(function(ls){
            prices.push({
                id: ls.id,
                product_qty: l.product_qty,
                price_unit: l.price_unit,
                date_planned: l.date_planned
            }) ;
        }) ;
    }) ;
    this.view.longTask(function(done){
        this.api.public.saveRfqPrice(this.data.token, prices, this.data.comment, function(err){
            if(err){ return done(err) ;}
            done() ;
            this.view.info(WebView.tr("rfq.savePriceOk")) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

rfqPriceController.onFillRequest = function(){
    this.data.refused = false ;
    this.view.render() ;
} ;

rfqPriceController.onRefuse = function(){
    this.view.confirm(WebView.tr("rfq.confirmRefuse"), function(yes){
        if(yes){
            this.view.updateData() ;
            this.view.longTask(function(done){
                this.api.public.refuseRfqPrice(this.data.token, this.data.comment, function(err){
                    if(err){ return done(err) ;}
                    done() ;
                    this.view.info(WebView.tr("rfq.refusPriceOk")) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }
    }.bind(this)) ;
} ;


module.exports = rfqPriceController ;